<template>
  <div class="content">
    <!-- <PageHeader title="Omni Business" subtitle="Respostas do sistema" /> -->
    <PageHeader title="Chat" subtitle="Respostas do sistema" />
    <div class="page-content container-fluid">
      <!-- <div class="qt-block-ui" v-if="loading"></div> -->
    <div class="loading min-h-300" v-if="loading">
      <LoadingAnim />
    </div>
      <template v-else>
        <div class="row">
          <div class="col-lg-2 col-md-2">
            <h3 class="left-title">Variáveis</h3>
            <p class="card-info-p">Crie variáveis para  solicitar informações no seu atendimento.</p>
          </div>
          <div class="col-lg-10 col-md-10">
            <div class="row">
              <div class="col-md-4 hide">
                <h4 class="card-subtitles" style="padding-left: 0;">Adicionar variáveis:</h4>
                <p class="card-info-p">Defina uma nova variável para o seu sistema de atendimento </p>
              </div>
              <div class="col-sm-8 hide">
                <div class="input-new-var">
                  <input type="text" class="form-control" placeholder="Ex.: Email"/>
                </div>
              </div>
              <div class="col-md-12 hide">
                <br>
              </div>
              <div class="col-md-12">
                <h4 class="card-subtitles" style="padding-left: 0;">Minhas variáveis:</h4>
                <div class="text-right">
                  <span class="material-symbols-outlined c-pointer" v-if="varsVisible" @click="varsVisible = !varsVisible">
                    keyboard_arrow_up
                  </span>
                  <span class="material-symbols-outlined c-pointer" v-if="!varsVisible" @click="varsVisible = !varsVisible">
                    keyboard_arrow_down
                  </span>
                </div>
              </div>
              <div class="col-md-12">
                <br>
              </div>
              <div class="col-md-12">
                <b-collapse v-model="varsVisible">
                  <div v-for="(tag, i) in tags" :key="i">
                    <span class="tag-vars">{{tag.tag}}</span>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <br><br><br>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="thanks">
                <div class="to-left">
                  Agradecimento
                  </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Esta mensagem não aceita tags.'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Uma mensagem de agradecimento do contato é uma expressão de gratidão enviada a um cliente ou pessoa com quem se teve interação.</p>
                <p v-if="!hasEditThanks">{{form.thanks}}</p>
                <textarea class="form-control" v-model="form.thanks" id="thanks" v-if="hasEditThanks"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditThanks = !hasEditThanks">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="client_end">
                <div class="to-left">
                  Quando o cliente finalizar
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure uma mensagem para avaliação do atendimento quando o cliente finalizar'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">A mensagem de finalização automática do chat é uma mensagem que é enviada automaticamente para o usuário final após a finalização do chat.</p>
                <div class="row">
                  <div class="col-md-6 p-r-0">
                    <h5 class="left-title" style="padding-left: 0;">Enviar mensagem de avaliação</h5>
                  </div>
                  <div class="col-md-6 text-right">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" name="notifications-opt" v-model="form.has_satisfaction_question" @change="save"/>
                        <div class="control_indicator" style="margin-right: 0px;"></div>
                      </label>
                    </div>
                  </div>
                </div>
                <p v-if="!hasEditClientEnd && form.has_satisfaction_question">{{ form.client_end }}</p>
                <textarea v-if="hasEditClientEnd && form.has_satisfaction_question" class="form-control" v-model="form.client_end" id="client_end"></textarea>
              </div>
              <div class="card-footer text-right" v-if="form.has_satisfaction_question">
                <button class="btn-edit-answer" @click="hasEditClientEnd = !hasEditClientEnd">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="widget">
                <div class="to-left">
                  Mensagem no widget
                </div>
                <div class="to-right text-right">
                  <!-- <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Realize a configuração de seu widget em Omni Business >Widget.'"/> -->
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Realize a configuração de seu widget em Chat &gt; Widget.'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">A mensagem de agradecimento no Widget é uma forma de expressar gratidão em um widget.</p>
                <p v-if="!hasEditWidget">{{ form.widget }}</p>
                <textarea class="form-control" v-model="form.widget" id="widget" v-if="hasEditWidget"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditWidget = !hasEditWidget">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <!-- <div class="card-answer">
              <label class="card-header" for="service_end">Atendimento encerrado</label>
              <div class="card-body">
                <textarea class="form-control" v-model="form.service_end" id="service_end"></textarea>
              </div>
            </div> -->
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="transfer">
                <div class="to-left" style="width: 90%;">
                  Transferir para outro agente
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure a mensagem de transferência para seus agentes. Adicione variáveis.'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Mensagem exibida ao cliente antes de ele selecionar o agente específico para o qual deseja transferir o atendimento.</p>
                <p v-if="!hasEditTransfer">{{ form.transfer }}</p>
                <textarea v-if="hasEditTransfer" class="form-control" v-model="form.transfer" id="transfer"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditTransfer = !hasEditTransfer">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="satisfaction">
                <div class="to-left" style="width: 90%;">
                  Avaliação do agente
                  <img style="width: 15px; height: 15px; margin-top: 0px;" src="assets/img/icons/circle_info.png" class="circle-info" v-tooltip.top="'Avalia o usuário após o atendimento.'"/>
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Avalia o usuário após o atendimento'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Mensagem de participação na pesquisa de satisfação é uma comunicação enviada ao cliente para solicitar sua participação em uma pesquisa de satisfação ou para finalizar o atendimento</p>
                <p v-if="!hasEditSatisfaction">{{ form.satisfaction }}</p>
                <textarea v-if="hasEditSatisfaction" class="form-control" v-model="form.satisfaction" id="satisfaction"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditSatisfaction = !hasEditSatisfaction">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="auto_end">
                <div class="to-left" style="width: 90%;">
                  Quando a sala fechar automática
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Crie uma mensagem quando o atendimento fechar automaticamente.'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Uma mensagem de finalização automática do chat é uma mensagem pré-programada que é enviada automaticamente para encerrar uma conversa em um chat.</p>
                <p v-if="!hasEditAutoEnd">{{ form.auto_end }}</p>
                <textarea v-if="hasEditAutoEnd" class="form-control" v-model="form.auto_end" id="auto_end"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditAutoEnd = !hasEditAutoEnd">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="transfer_department">
                <div class="to-left" style="width: 90%;">
                  Transferir para outro departamento
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure a mensagem e adicione variáveis para realizar a transferência de atendimento para um de seus departamentos.'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Mensagem exibida ao cliente antes de ele selecionar o departamento específico para o qual deseja enviar uma mensagem.</p>
                <p v-if="!hasEditTransferDepartment">{{ form.transfer_department }}</p>
                <textarea v-if="hasEditTransferDepartment" class="form-control" v-model="form.transfer_department" id="transfer_department"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditTransferDepartment = !hasEditTransferDepartment">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="reopen">
                <div class="to-left">
                  Reabertura de sala
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure uma mensagem automática para reabertura da sala de atendimento'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Uma mensagem de reabertura do chat é uma mensagem enviada ao cliente apresentando a opção de reabrir o chat.</p>
                <p v-if="!hasEditReopen">{{ form.reopen }}</p>
                <textarea v-if="hasEditReopen" class="form-control" v-model="form.reopen" id="reopen"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditReopen = !hasEditReopen">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="before_dept">
                <div class="to-left" style="width: 90%;">
                  Mensagem de apresentação
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure uma mensagem de apresentação, seja breve e  utilize nosso recurso de variáveis.'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Uma mensagem de apresentação do chat é uma mensagem enviada ao cliente apresentando a opção de iniciar o chat.</p>
                <p v-if="!hasEditBefore">{{ form.before_dept }}</p>
                <textarea v-if="hasEditBefore" class="form-control" v-model="form.before_dept" id="before_dept"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditBefore = !hasEditBefore">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="dept_inv_fast">
                <div class="to-left">
                  Opção inválida rápido
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure uma mensagem de erro de opção inválida'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Mensagem que informa ao cliente que ele fez uma opção inválida com respostas rápidas.</p>
                <p v-if="!hasEditDeptFast">{{ form.dept_inv_fast }}</p>
                <textarea v-if="hasEditDeptFast" class="form-control" v-model="form.dept_inv_fast" id="dept_inv_fast"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditDeptFast = !hasEditDeptFast">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="dept_inv">
                <div class="to-left">
                  Opção inválida
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure uma mensagem de erro para opção inválida'"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Mensagem que informa ao cliente que ele fez uma opção inválida e que precisa selecionar um departamento válido.</p>
                <p v-if="!hasEditDept">{{ form.dept_inv }}</p>
                <textarea v-if="hasEditDept" class="form-control" v-model="form.dept_inv" id="dept_inv"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditDept = !hasEditDept">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-answer min-h-350">
              <label class="card-header" style="display: block;" for="return_queue">
                <div class="to-left">
                  Retornar para fila
                </div>
                <div class="to-right text-right">
                  <img style="width: 24px; height: 24px; margin-top: 0px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Configure uma mensagem padrão para retorno de fila, lembre-se de adicionar variáveis '"/>
                </div>
                <div style="clear:both"></div>
              </label>
              <div class="card-body">
                <p class="card-info-p-card">Mensagem que informa ao cliente que ele será retornado para a fila de atendimento.</p>
                <p v-if="!hasEditQueue">{{ form.return_queue }}</p>
                <textarea v-if="hasEditQueue" class="form-control" v-model="form.return_queue" id="return_queue"></textarea>
              </div>
              <div class="card-footer text-right">
                <button class="btn-edit-answer" @click="hasEditQueue = !hasEditQueue">Editar <span class="material-symbols-outlined">mode</span></button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <br><br><br><br>
          </div>
        </div>
        <div class="card-bottom-btns-save">
          <div class="row">
            <div class="col-sm-8 card-bottom-btns-save-icon">
              <!-- <img src="assets/img/icons/system_settings.svg" /> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="34.188" height="30.602" viewBox="0 0 34.188 30.602">
                <path id="system_settings" data-name="system settigns" d="M-309.652,659.629a.586.586,0,0,1-.4-.149.624.624,0,0,1-.211-.358l-.294-2.018a5.306,5.306,0,0,1-.936-.431,5.225,5.225,0,0,1-.852-.6l-1.85.863a.668.668,0,0,1-.453.01.618.618,0,0,1-.346-.284l-1.136-2.019a.524.524,0,0,1-.063-.431.6.6,0,0,1,.252-.346l1.684-1.263a3.923,3.923,0,0,1-.063-.472c-.015-.175-.021-.34-.021-.495s.006-.3.021-.474a4.82,4.82,0,0,1,.063-.495l-1.684-1.261a.6.6,0,0,1-.252-.347.525.525,0,0,1,.063-.431l1.136-2a.683.683,0,0,1,.346-.294.515.515,0,0,1,.431.022l1.852.84a5.786,5.786,0,0,1,.863-.589,5.33,5.33,0,0,1,.926-.421l.315-2.04a.633.633,0,0,1,.211-.358.585.585,0,0,1,.4-.147h2.271a.6.6,0,0,1,.389.147.611.611,0,0,1,.221.358l.294,2.04a7.42,7.42,0,0,1,.936.421,3.831,3.831,0,0,1,.832.589l1.893-.84a.545.545,0,0,1,.431-.032.633.633,0,0,1,.347.284l1.136,2a.579.579,0,0,1,.074.442.545.545,0,0,1-.264.358l-1.7,1.241c.029.168.05.337.063.5s.022.33.022.484-.007.294-.022.462-.034.344-.063.525l1.7,1.242a.549.549,0,0,1,.241.346.552.552,0,0,1-.074.431l-1.135,2.019a.62.62,0,0,1-.347.284.538.538,0,0,1-.431-.031l-1.872-.842a7.249,7.249,0,0,1-.842.6,3.564,3.564,0,0,1-.926.409l-.294,2.04a.6.6,0,0,1-.221.358.6.6,0,0,1-.389.149Zm-.568-9.678a2.292,2.292,0,0,0-.695,1.684,2.287,2.287,0,0,0,.695,1.682,2.287,2.287,0,0,0,1.682.695,2.287,2.287,0,0,0,1.682-.695,2.287,2.287,0,0,0,.695-1.682,2.292,2.292,0,0,0-.695-1.684,2.291,2.291,0,0,0-1.682-.693A2.291,2.291,0,0,0-310.22,649.951Zm-13.053,4.186a2.3,2.3,0,0,1-1.769-.845,2.382,2.382,0,0,1-.5-1.977,2.4,2.4,0,0,1,2.4-1.887h1.481a2.324,2.324,0,0,1,2.025,1.178h1.858a9.993,9.993,0,0,0-.074,1.213,9.85,9.85,0,0,0,.066,1.141h-1.849a2.36,2.36,0,0,1-2.027,1.177Zm5.537-7.062a1.575,1.575,0,0,1-1.571-1.575v-5.486a1.573,1.573,0,0,1,1.571-1.572h.784a3.144,3.144,0,0,1,3.138,3.144v2.3a9.9,9.9,0,0,0-2.807,3.173,3.188,3.188,0,0,1-.331.018Zm-10.2,0a3.147,3.147,0,0,1-3.14-3.145v-2.345a3.144,3.144,0,0,1,3.14-3.143l.74,0a1.571,1.571,0,0,1,1.569,1.571l.044,5.49a1.573,1.573,0,0,1-1.569,1.573ZM-335,643.542v-1.961a13.226,13.226,0,0,1,3.73-8.8,12.223,12.223,0,0,1,8.826-3.759,12.222,12.222,0,0,1,8.826,3.759,13.225,13.225,0,0,1,3.73,8.8v.6a9.741,9.741,0,0,0-2.355.77v-1.367a10.208,10.208,0,0,0-10.2-10.192,10.208,10.208,0,0,0-10.2,10.192v1.961a1.249,1.249,0,0,1-1.222,1.177A1.171,1.171,0,0,1-335,643.542Z" transform="translate(335 -629.026)"/>
              </svg>
              <h4>Ajustes do Sistema</h4>
            </div>
            <div class="col-sm-4 text-right d-flex align-items-center">
              <button class="btn btn-yup-purple ml-auto mr-3" @click="save">Salvar alterações</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import Emojis from '@/components/Emojis.vue';
import PageHeader from '@/components/rebranding/PageHeader.vue';
// import { ToggleButton } from 'vue-js-toggle-button';
import axios from '@/plugins/axios';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';

export default {
  name: 'Responses',
  components: {
    // InfiniteLoading,
    // Emojis,
    PageHeader,
    // ToggleButton,
    LoadingAnim,
  },
  data() {
    return {
      loading: true,
      hasEditDept: false,
      hasEditThanks: false,
      hasEditBefore: false,
      hasEditAutoEnd: false,
      hasEditTransfer: false,
      hasEditDeptFast: false,
      hasEditClientEnd: false,
      hasEditTransferDepartment: false,
      hasEditQueue: false,
      hasEditSatisfaction: false,
      hasEditReopen: false,
      hasEditWidget: false,
      varsVisible: true,
      form: {
        satisfaction: '',
        has_satisfaction_question: false,
        thanks: '',
        transfer: '',
        reopen: '',
        widget: '',
        before_dept: '',
        auto_end: '',
        dept_inv: '',
        dept_inv_fast: '',
        client_end: '',
        // service_end: '',
        transfer_department: '',
        return_queue: '',
      },
      tags: [
        { tag: '[FOO]', descrição: 'Macdonald' },
      ],
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
  mounted() {
    axios().get('webchat/responses').then((response) => {
      const form = this.form;
      const data = response.data;

      Object.keys(form).forEach((key) => {
        if (data[key]) form[key] = data[key];
      });

      return axios().get('webchat/tags').then((response) => {
        this.loading = false;
        this.tags = response.data;
      });
    }).catch((error) => {
      this.loading = false;
      console.error('responses', error);
    });
  },
  methods: {
    save() {
      this.loading = true;

      axios().put('webchat/responses', this.form).then((response) => {
        this.loading = false;
        this.hasEditDept = false;
        this.hasEditThanks = false;
        this.hasEditBefore = false;
        this.hasEditAutoEnd = false;
        this.hasEditTransfer = false;
        this.hasEditDeptFast = false;
        this.hasEditClientEnd = false;
        this.hasEditTransferDepartment = false;
        this.hasEditQueue = false;
        this.hasEditSatisfaction = false;
        this.hasEditReopen = false;
        this.hasEditWidget = false;
        console.log('responses', response);
        this.$toast.show({
          title: 'Sucesso',
          content: 'Respostas atualizadas',
          type: 'success',
        });
      }).catch((error) => {
        this.loading = false;
        console.error('responses', error);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.qt-block-ui {
  min-height: 200px;
}

textarea {
  min-height: 95px;
}

.card-footer {
  font-size: 9pt;
  background: #eef4ff;
}
.card-header {
  font-size: 20px !important;
  font-weight: 600 !important;
  background: none;
  border: none;
}
.card-subtitles {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
}
.to-left {
  float: left !important;
}
.to-right{
  float: right !important;
}
.card {
  min-height: 270px !important;
}
.darkmode .modal-content, .darkmode .card, .darkmode .card-footer {
  background-color: var(--background-2) !important;
}
.darkmode span {
  color: #fff !important;
}
.min-h-350 {
  min-height: 350px !important;
}
.card-bottom-btns-save {
  width: 90%;
  height: 60px;

  background: var(--background-3) 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000029;
  border: 1px solid var(--background-3);
  border-radius: 4px;
  opacity: 1;
  position: fixed;
  bottom: 10px;
}
.btn-save-blue {
  background: #752DE6 !important;
  margin-bottom: 10px;
  margin: 10px;
}
.card-bottom-btns-save-icon {
  display: flex;
}
.card-bottom-btns-save-icon img {
  width: 40px;
  height: 35px;
}
.card-bottom-btns-save-icon h4{
  font-size: 15px;
  margin-left: 10px;
  margin-top: 5px;
}
.card-bottom-btns-save-icon {
  padding: 15px;
  padding-left: 30px;
}

.darkmode .modal-content, .darkmode .card, .darkmode .card-footer {
  background-color: var(--background-2) !important;
}

#system_settings {
  fill: var(--clr-yup-purple);
}

.darkmode #system_settings {
  fill: #fff;
}
.card-answer {
  border: solid #E5E5E5 1px;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 20px;
  position: relative;
}
.card-body p {
  display: block;
  background: #F8F8F8;
  border-radius: 8px;
  padding: 15px;
  font-size: 10px;
}
.btn-edit-answer {
  color: #6B23DC;
  background: none;
  padding: 0px;
  margin: 0px;
  font-size: 12px;
  font-weight: 700;
  border: none;
}
.btn-edit-answer:hover {
  color: #752de9;
}
.btn-edit-answer span {
  font-size: 15px;
  display: block;
  float: right;
  margin-left: 3px;
  margin-top: 2px;
}
.card-footer {
  background: none;
}
.card-subtitles {
  color: #0D0519;
  font-size: 14px;
  font-weight: 400;
}
.left-title {
  color: #0D0519;
  font-size: 16px;
  font-weight: 700;
}
.tag-vars {
  background: #807C8D14;
  border-radius: 8px;
  display: block;
  float: left;
  padding: 4px 8px 4px 8px;
  margin-right: 10px;
  color: #807C8D;
  font-size: 12px;
  font-weight: 400;
}
.card-info-p {
  color: #AAAAAA;
  font-size: 12px;
  font-weight: 400;
  background: #fff !important;
  padding: 0px !important;
}
.card-info-p-card {
  color: #807C8D !important;
  font-size: 12px !important;
  font-weight: 400;
  background: #fff !important;
  padding: 0px !important;
}
.input-new-var input{
  border: solid 1px #E5E5E5;
  padding: 10px;
  border-radius: 4px;
}
.c-pointer {
  cursor: pointer;
}
.card-footer {
  position: absolute;
  bottom: 5px;
  right: 0px;
}
</style>
